module.exports = __webpack_public_path__ + "img/icon-book.c2250a3.png";